export const Data = [
  {
    title: "Monolithic Architecture",
    subtitle: "Monolithic Architecture understanding",
    filepath: "/microservices/Monolithic.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: " Service oriented Architecture",
    subtitle: "soaa???",
    filepath: "/microservices/soa.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "MicroServices",
    subtitle: "Microservices???",
    filepath: "/microservices/MicroSerice.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Cmporasion and when",
    subtitle: "Micro,SOA,MONO???",
    filepath: "/microservices/when.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Microservice-Communication",
    subtitle: "inter process communication???",
    filepath: "/microservices/Microservice-commun.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Building MicroService",
    subtitle: "How to build a Microservice???",
    filepath: "/microservices/Building-Ms.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Spring Refresher",
    subtitle: "Bean,Autowiring???",
    filepath: "/microservices/Sref.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "WAR and EAR ",
    subtitle: "War and ear files ???",
    filepath: "/microservices/EARWAR.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Microservices REST services  ",
    subtitle: "standards and details ???",
    filepath: "/microservices/Rest.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "DTO  ",
    subtitle: "Data Transfer Object ???",
    filepath: "/microservices/DTO.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
];
